// 

export default class Case {

    constructor(name, mass, M, l, alpha, beta) {
        this.name = name;
        this.mass = mass;
        this.M = M;
        this.l = l;
        this.alpha = alpha;
        this.beta = beta;
    }
    get weight() {
        return this.weightFunction()
    }
    weightFunction() {
        return (this.mass * 9.8).toFixed(1)// in newtons
    }


    dFunction() {
        return (Math.abs(Math.sin(this.alpha) * this.l)).toFixed(2)
    }

    get d() {
        return this.dFunction()
    }

    DFunction() {
        return (0.5 * this.M * Math.cos(this.beta)).toFixed(2)
    }

    get D() {
        return this.DFunction()
    }

    weightComponentsFunction() {
        let W = this.weightFunction()
        let [Wx, Wy] = [Math.cos(this.beta) * W, Math.sin(this.beta) * W]
        return [Wx, Wy]
    }

    get weightComponents() {
        return this.weightComponentsFunction()
    }

    muscleForceFunction() {
        let W = this.weightFunction()
        let d = this.dFunction()
        let D = this.DFunction()
        return (W * D / d).toFixed(1)
    }

    get muscleForce() {
        return this.muscleForceFunction()
    }

    muscleForceComponentsFunction() {
        let F = this.muscleForceFunction()
        let Fx = F * Math.cos(this.alpha)
        let Fy = - F * Math.sin(this.alpha)
        return [Fx, Fy]
    }

    get muscleForceComponents() {
        return this.muscleForceComponentsFunction()
    }

    hipJRFComponentsFunction() {
        let [Wx, Wy] = this.weightComponentsFunction()
        let [Fx, Fy] = this.muscleForceComponentsFunction()
        return [-(Fx + Wx), -(Fy + Wy)]
    }

    get hipJRFComponents() {
        return this.hipJRFComponentsFunction()
    }

    hipJRFmagnitudeFunction() {
        let [Hx, Hy] = this.hipJRFComponentsFunction()
        let magnitude = (Math.sqrt(Hx ** 2 + Hy ** 2)).toFixed(1)
        return magnitude
    }

    get hipJRFmagnitude() {
        return this.hipJRFmagnitudeFunction()
    }

    hipJRFangleFunction() {
        let [Hx, Hy] = this.hipJRFComponentsFunction()
        let hipJRF = this.hipJRFmagnitudeFunction()
        return ((Math.asin(Hx / hipJRF))*180/Math.PI).toFixed(1)
    }

    get hipJRFangle() {
        return this.hipJRFangleFunction()
    }
}
